<script>
  export let icon = "arrow_right";
  export let disable = false;
  export let small = false;
  export let medium = false;
  export let notificationNumber = 0;
  export let disabledNotification = 0;
  export let long = false;
  export let rounded = false;
  export let title = "";
  export let ariaLabel = title;

  $: iconSource = icon.startsWith("/") ? icon : `/img/assistant/icons/${icon}.svg`;
  $: resolvedAriaLabel = ariaLabel || title || icon;
</script>

<button
  class="button_wrapper {small ? 'small' : ''} {medium ? 'medium' : ''} {long
    ? 'long'
    : ''}"
  on:click
  class:disable
  class:rounded
  {title}
  aria-label={resolvedAriaLabel}
>
  <img src={iconSource} alt="" aria-hidden="true" />
</button>
{#if notificationNumber}
  <div class="number">
    {disabledNotification > 0
      ? notificationNumber - disabledNotification + " of "
      : ""}{notificationNumber}
  </div>
{/if}

<style>
  .button_wrapper {
    cursor: pointer;
    display: flex;
    height: 3rem;
    width: 3rem;
    align-items: center;
    justify-content: center;
    border-radius: 0.5rem;
    background-color: var(--pax-black);
    color: var(--pax-white);
    transition: 300ms ease-in-out;
  }

  .button_wrapper:hover {
    background-color: #2a2a2f;
    color: var(--pax-white);
  }

  .disable {
    cursor: not-allowed;
    opacity: 70%;
    background-color: var(--pax-black);
    color: var(--pax-white);
  }

  .disable:hover {
    cursor: not-allowed;
    opacity: 70%;
    background-color: var(--pax-black);
    color: var(--pax-white);
  }

  .small {
    height: 2rem;
    width: 2rem;
  }

  .medium {
    height: 2.5rem;
    width: 2.5rem;
  }

  .long {
    height: 4rem;
    border-radius: 0.3125rem;
    width: 2.5rem;
  }

  .rounded {
    border-radius: 100%;
  }

  .number {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 1em;
    min-width: 1.3rem;
    height: 1.3rem;
    color: var(--pax-white);
    background-color: var(--pax-orange);
    border: 0.1rem solid var(--pax-orange);
    z-index: 1;
    position: absolute;
    text-align: center;
    right: 0.7rem;
    font-weight: bold;
    top: 0.2rem;
    padding: 0.3rem;
  }
</style>
